<!-- src/views/MessagePush.vue -->
<template>

   <el-card class="message-history-card">
      <template #header>
        <div class="card-header">
          <span>推送历史</span>
          <el-button
            size="small"
            @click="fetchMessageHistory"
            :loading="historyLoading"
          >
            刷新
          </el-button>
        </div>
      </template>

      <el-table
        :data="messageHistory"
        style="width: 100%"
        v-loading="historyLoading"
      >
        <el-table-column prop="title" label="标题"  />
        <el-table-column prop="content" label="内容" />
        <el-table-column prop="type" label="类型" >
          <template #default="scope">
            <el-tag :type="getMessageTypeTag(scope.row.type)">
              {{ getMessageTypeText(scope.row.type) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="timestamp" label="时间" >
          <template #default="scope">
            {{ formatTimestamp(scope.row.timestamp) }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card class="message-form-card">
      <template #header>
        <div class="card-header">
          <span>消息推送</span>
        </div>
      </template>

      <el-form
        :model="messageForm"
        :rules="rules"
        ref="messageFormRef"
        label-width="100px"
        class="message-form"
      >
        <el-form-item label="消息标题" prop="title">
          <el-input
            v-model="messageForm.title"
            placeholder="请输入消息标题"
          />
        </el-form-item>

        <el-form-item label="消息内容" prop="content">
          <el-input
            v-model="messageForm.content"
            type="textarea"
            :rows="4"
            placeholder="请输入消息内容"
          />
        </el-form-item>

        <el-form-item label="消息类型" prop="type">
          <el-select v-model="messageForm.type" placeholder="请选择消息类型">
            <el-option
              v-for="item in messageTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="submitMessage"
            :loading="loading"
          >
            发送消息
          </el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button @click="sendTestMessage" :loading="testLoading">
            发送测试消息
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>



    <el-dialog
      v-model="dialogVisible"
      title="推送结果"
      width="30%"
    >
      <div class="result-dialog">
        <el-result
          :icon="pushResult.success ? 'success' : 'error'"
          :title="pushResult.title"
          :sub-title="pushResult.message"
        />
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">确定</el-button>
        </span>
      </template>
    </el-dialog>

</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'

export default {
  name: 'MessagePush',
  setup() {
    const messageFormRef = ref()
    const loading = ref(false)
    const testLoading = ref(false)
    const historyLoading = ref(false)
    const dialogVisible = ref(false)

    const messageForm = reactive({
      title: '',
      content: '',
      type: 'info'
    })

    const pushResult = reactive({
      success: false,
      title: '',
      message: ''
    })

    const messageTypes = [
      { value: 'info', label: '信息' },
      { value: 'success', label: '成功' },
      { value: 'warning', label: '警告' },
      { value: 'error', label: '错误' }
    ]

    const messageHistory = ref([])

    const rules = {
      title: [
        { required: true, message: '请输入消息标题', trigger: 'blur' }
      ],
      content: [
        { required: true, message: '请输入消息内容', trigger: 'blur' }
      ],
      type: [
        { required: true, message: '请选择消息类型', trigger: 'change' }
      ]
    }

    // 提交消息
    const submitMessage = async () => {
      if (!messageFormRef.value) return

      await messageFormRef.value.validate(async (valid) => {
        if (valid) {
          loading.value = true

          try {
            const response = await fetch('/api/push_message', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`
              },
              body: JSON.stringify({
                title: messageForm.title,
                content: messageForm.content,
                msg_type: messageForm.type
              })
            })

            const result = await response.json()

            if (response.ok) {
              showResult(true, '推送成功', result.message)
              resetForm()
              fetchMessageHistory() // 刷新历史记录
            } else {
              showResult(false, '推送失败', result.detail || '未知错误')
            }
          } catch (error) {
            showResult(false, '推送失败', error.message)
          } finally {
            loading.value = false
          }
        }
      })
    }

  // 发送测试消息 (POST方式)
 const sendTestMessage = async () => {
    testLoading.value = true

  try {
    const response = await fetch('/api/test_push', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
      },
      body: JSON.stringify({
        title: messageForm.title || '测试消息标题',
        content: messageForm.content || '这是一条测试消息，请忽略。',
        msg_type: messageForm.type || 'info'
      })
    })

    const result = await response.json()

    if (response.ok) {
      showResult(true, '测试消息发送成功', result.message)
      fetchMessageHistory() // 刷新历史记录
    } else {
      showResult(false, '测试消息发送失败', result.detail || '未知错误')
    }
  } catch (error) {
    showResult(false, '测试消息发送失败', error.message)
  } finally {
    testLoading.value = false
  }
}


    // 显示结果对话框
    const showResult = (success, title, message) => {
      pushResult.success = success
      pushResult.title = title
      pushResult.message = message
      dialogVisible.value = true

      if (success) {
        ElMessage.success(message)
      } else {
        ElMessage.error(message)
      }
    }

    // 重置表单
    const resetForm = () => {
      messageForm.title = ''
      messageForm.content = ''
      messageForm.type = 'info'

      if (messageFormRef.value) {
        messageFormRef.value.resetFields()
      }
    }

    // 修改 fetchMessageHistory 函数从后端获取真实数据
const fetchMessageHistory = async () => {
  historyLoading.value = true

  try {
    // 调用后端API获取消息历史
    const response = await fetch('/api/message_history', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
      }
    })

    if (response.ok) {
      const data = await response.json()
      // 假设后端返回的数据在 data 字段中
      messageHistory.value = data
    } else {
      throw new Error('获取消息历史失败')
    }
  } catch (error) {
    ElMessage.error('获取消息历史失败: ' + error.message)
  } finally {
    historyLoading.value = false
  }
}


    // 获取消息类型标签
    const getMessageTypeTag = (type) => {
      const typeMap = {
        'success': 'success',
        'warning': 'warning',
        'error': 'danger',
        'info': 'info'
      }
      return typeMap[type] || 'info'
    }

    // 获取消息类型文本
    const getMessageTypeText = (type) => {
      const textMap = {
        'success': '成功',
        'warning': '警告',
        'error': '错误',
        'info': '信息'
      }
      return textMap[type] || '信息'
    }

    // 格式化时间戳
    const formatTimestamp = (timestamp) => {
      if (!timestamp) return ''

      try {
        const date = new Date(timestamp)
        return date.toLocaleString('zh-CN')
      } catch (error) {
        return timestamp
      }
    }

    // 组件挂载时获取历史记录
    onMounted(() => {
      fetchMessageHistory()
    })

    return {
      messageFormRef,
      loading,
      testLoading,
      historyLoading,
      dialogVisible,
      messageForm,
      pushResult,
      messageTypes,
      messageHistory,
      rules,
      submitMessage,
      sendTestMessage,
      resetForm,
      fetchMessageHistory,
      getMessageTypeTag,
      getMessageTypeText,
      formatTimestamp
    }
  }
}
</script>

<style scoped>
.message-push-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.message-form-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.message-form {
  max-width: 600px;
}

.result-dialog {
  text-align: center;
}

.dialog-footer {
  text-align: right;
}

.message-history-card {
  margin-bottom: 20px;
}
.el-table__header{
  min-height: 250px;
}
.el-table__body{
  max-height: 500px;
  width: 100% !important;
}
</style>
